<template>
  <div class="pg-layout-tab">
    <div class="pg-layout-tab__left" ref="layoutTabContain" @wheel="onScroll">
      <transition-group
        tag="div"
        class="pg-layout-tab__left-box"
        name="pg-layout-tab__left-item-transition"
        ref="layoutTab"
      >
        <template v-if="menuList?.length > 0">
          <div
            class="pg-layout-tab__left-item"
            :class="{ 'pg-layout-tab__left-item--active': item.id === activeMenu?.id }"
            v-for="item in menuList"
            :key="item.id"
            @click="onChange(item)"
          >
            <div class="pg-layout-tab__left-item-box">
              <span class="pg-layout-tab__left-item-text" :title="item.title">{{
                item.title
              }}</span>
              <i
                class="el-icon-refresh-right"
                style="margin-left: 10px"
                v-if="!~iconHides.indexOf(item.name) && activeMenu?.id === item.id"
                @click.stop="onRefresh(item.name)"
              ></i>
              <i
                style="margin-left: 10px"
                class="el-icon-close"
                v-if="!~iconHides.indexOf(item.name)"
                @click.stop="onClose(item)"
              ></i>
            </div>
          </div>
        </template>
      </transition-group>
    </div>
    <Dropdown class="pg-layout-tab__right" trigger="click" @command="handCommand">
      <span class="pg-layout-tab__right-down">
        标签选项<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <template v-slot:dropdown>
        <DropdownMenu class="pg-layout-tab__right-down-menu">
          <DropdownItem class="pg-layout-tab__right-down-item" command="all">关闭所有</DropdownItem>
          <DropdownItem class="pg-layout-tab__right-down-item" command="other"
            >关闭其他</DropdownItem
          >
        </DropdownMenu>
      </template>
    </Dropdown>
  </div>
</template>
<script setup>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import Sortable from 'sortablejs'
import { ref, onMounted, onBeforeUnmount } from 'vue'
const props = defineProps({
  menuList: {
    type: Array,
    default: null,
  },
  activeMenu: {
    type: Object,
    default: null,
  },
  iconHides: {
    type: Array,
    default: () => ['home_index'],
  },
})

const emit = defineEmits(['on-change', 'on-command', 'on-refresh', 'on-close', 'on-sortable'])
const onChange = (menu) => {
  if (props.activeMenu?.id === menu?.id) return
  emit('on-change', menu)
}
const handCommand = (command) => {
  emit('on-command', command)
}
const onRefresh = (name) => {
  emit('on-refresh', name)
}
const onClose = (menu) => {
  emit('on-close', menu)
}

const layoutTab = ref(null)
let sorTableExample = null
onMounted(() => {
  sorTableExample = Sortable.create(layoutTab.value.$el, {
    group: {
      name: 'layout-tab',
      pull: true,
    },
    animation: 120,
    // ghostClass: '',
    // fallbackClass: '',
    dragClass: 'pg-layout-tab__left-item--drag',
    onUpdate(event) {
      emit('on-sortable', { to: event.newIndex, from: event.oldIndex })
    },
  })
})
onBeforeUnmount(() => {
  sorTableExample?.destroy()
})

const layoutTabContain = ref(null)
const onScroll = (event) => {
  const scrollWidth = layoutTabContain.value?.scrollWidth
  const offsetWidth = layoutTabContain.value?.offsetWidth
  layoutTabContain.value.scrollLeft = Math.max(
    Math.min(layoutTabContain.value.scrollLeft + event.deltaY, scrollWidth - offsetWidth),
    0
  )
}
</script>
<style lang="scss">
@import '../style/layout-tab.scss';
</style>
